module.exports = __webpack_public_path__ + "img/ico_zbshhq.3b9b465b.png";